<div
  class="full-width"
  *ngFor="let param of parameters; trackBy: trackByKey"
  data-dgat="reporting-create-report-parameters-41b"
>
  <ng-container [ngSwitch]="param.type">
    <div
      class="rel"
      data-dgat="reporting-create-report-parameters-6f1"
      *ngSwitchCase="'InputIdentifier'"
    >
      <ng-container
        *ngTemplateOutlet="inputSearch; context: param"
      ></ng-container>
    </div>
    <div
      class="rel"
      data-dgat="reporting-create-report-parameters-fb3"
      *ngSwitchCase="'InputIdentifierList'"
    >
      <ng-container
        *ngTemplateOutlet="inputListSearch; context: param"
      ></ng-container>
    </div>
    <ng-container *ngSwitchDefault>
      <!-- Ignore unknown parameter {{ param }} -->
    </ng-container>
  </ng-container>
</div>

<!-- Parameter Templates -->

<!-- InputIdentifier -->
<ng-template
  #inputSearch
  let-key="key"
  let-type="type"
  let-searchHandler="searchHandler"
  let-formatter="formatter"
>
  <label for="report-parameters--{{ key }}">{{
    i18n.dgDownloadableReports_Parameters_InputIdentifier_Name
  }}</label>
  <div class="rel guts-p-b-1" *ngIf="!selectionMap[key]">
    <div class="search-field search-field--typeahead">
      <!-- TODO: replace the degreedicons search icon with a df-icon -->
      <input
        id="report-parameters--{{ key }}"
        class="search-field__input ms-hide-x"
        type="text"
        [(ngModel)]="modelMap[key]"
        [disabled]="isDisabledMap[key]"
        (blur)="cancelSearch(key)"
        [ngbTypeahead]="searchHandler"
        [editable]="false"
        (selectItem)="handleSelect(key, $event)"
        [resultTemplate]="inputSearchItemResult"
        [inputFormatter]="formatter"
        attr.aria-label="{{
          i18n.dgDownloadableReports_Parameters_InputIdentifier_Name
        }}"
        placeholder="{{
          i18n.dgDownloadableReports_Parameters_InputIdentifier_Placeholder
        }}"
        data-dgat="reporting-create-report-parameters-6f1"
      />
    </div>
  </div>

  <div class="rel guts-m-b-1" *ngIf="selectionMap[key]">
    <dgx-resource-result
      class="left-text guts-p-h-1"
      [item]="selectionMap[key]"
      (remove)="handleRemove(key, selectionMap[key])"
      data-dgat="reporting-create-report-parameters-2ad"
    ></dgx-resource-result>
  </div>
</ng-template>

<!-- InputIdentifierList -->
<ng-template
  #inputListSearch
  let-key="key"
  let-type="type"
  let-searchHandler="searchHandler"
  let-formatter="formatter"
>
  <label for="report-parameters--{{ key }}">{{
    i18n.dgDownloadableReports_Parameters_InputIdentifierList_Name
  }}</label>
  <div class="rel guts-p-b-1">
    <div class="search-field search-field--typeahead">
      <!-- TODO: replace the degreedicons search icon with a df-icon -->
      <input
        id="report-parameters--{{ key }}"
        class="search-field__input ms-hide-x"
        type="text"
        [(ngModel)]="modelMap[key]"
        [disabled]="isDisabledMap[key]"
        (blur)="cancelSearch(key)"
        [ngbTypeahead]="searchHandler"
        [editable]="false"
        (selectItem)="handleSelect(key, $event, true)"
        [resultTemplate]="inputSearchItemResult"
        [inputFormatter]="formatter"
        attr.aria-label="{{
          i18n.dgDownloadableReports_Parameters_InputIdentifierList_Name
        }}"
        placeholder="{{
          i18n.dgDownloadableReports_Parameters_InputIdentifierList_Placeholder
        }}"
        data-dgat="reporting-create-report-parameters-af4"
      />
    </div>
  </div>

  <div class="rel guts-m-b-1" *ngIf="selectionMap[key]">
    <dgx-resource-result
      *ngFor="let item of selectionMap[key]; let isFirst = first"
      class="left-text guts-p-h-1"
      [ngClass]="{ 'border-top': !isFirst }"
      [item]="item"
      (remove)="handleRemove(key, item)"
      data-dgat="reporting-create-report-parameters-a2f"
    ></dgx-resource-result>
  </div>
</ng-template>

<!-- Shared Templates -->
<ng-template #inputSearchItemResult let-item="result">
  <dgx-resource-result
    [item]="item"
    class="left-text guts-p-h-1"
    data-dgat="reporting-create-report-parameters-0c3"
  ></dgx-resource-result>
</ng-template>
